




















































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {StockInWaitParams} from "../params";
import {LadingStatus} from "@/enums/status";
import {Component, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {stockInWait} from "@/modules/warehouses/services";
import {Lading} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {debounce} from "lodash";
import moment from "moment";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import {SiteTargetType} from '@/enums/type';
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {deleteLading} from "@/modules/ladings/services";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import {LadingStore} from "@/modules/ladings/store";
import PrintLading from "@/modules/ladings/Print/index.vue";
import StockInWaitExcel from "@/modules/warehouses/StockInWait/components/Excel/index.vue";
import TableToExcel from "@linways/table-to-excel";
import BillLadingStockInWaitTable from "@/modules/warehouses/shared/components/BillLadingStockInWaitTable/index.vue";

@Component({
    name: "StockInWait",
    components: {
        BillLadingStockInWaitTable,
        StockInWaitExcel,
        PrintLading,
        CustomerSelector, TooltipLabel, AInputBarCode, EmployeeSelector, LadingStatusLabel, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    moment = moment;
    params: StockInWaitParams = new StockInWaitParams();
    ladingCode = "";
    customerFilter = {
        customerRowGuid: undefined
    }
    siteTargetType = SiteTargetType
    LadingStatus = LadingStatus;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    billLadingsExcel = [] as any;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            fixed: 'left',
            width: 100,
            align: 'center'
        },
        {
            title: "Ngày, giờ chấp nhận",
            dataIndex: "ladingDate",
            key: "ladingDate",
            width: 150,
            fixed: "left",
            ellipsis: true,
            scopedSlots: {customRender: 'ladingDate'}
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150,
            fixed: "left",
            ellipsis: true,
            scopedSlots: {customRender: 'ladingCode'}
        },
        {
            title: "Nhân viên giữ",
            dataIndex: "acceptanceTargetType",
            key: "acceptanceTargetType",
            scopedSlots: {customRender: "acceptanceTargetType"},
            width: 150,
            ellipsis: true
        },
        // {
        //     title: "Mã đơn hàng",
        //     dataIndex: "orderCode",
        //     key: "orderCode",
        //     width: 150,
        //     ellipsis: true,
        //     scopedSlots: {customRender: 'orderCode'}
        // },
        {
            title: "Đại diện gửi",
            dataIndex: "locationFromId",
            key: "locationFromId",
            scopedSlots: {customRender: "locationFromId"},
            width: 200,
            ellipsis: true
        },
        {
            title: "Mã KH",
            dataIndex: "customer.customerCode",
            key: "customerCode",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'customerCode'}
        },
        // {
        //     title: "Người nhận",
        //     dataIndex: "locationToId",
        //     key: "locationToId",
        //     scopedSlots: {customRender: "locationToId"},
        //     width: 200,
        //     ellipsis: true
        // },
        {
            title: "Địa chỉ giao hàng",
            dataIndex: "locationTo",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 200,
            ellipsis: true
        },
        // {
        //     title: "Hàng hóa",
        //     dataIndex: "boxContent",
        //     key: "boxContent",
        //     width: 150,
        //     ellipsis: true
        // },
        // {
        //     title: "Ngày lập",
        //     dataIndex: "ladingDate",
        //     key: "ladingDate",
        //     scopedSlots: {customRender: "ladingDate"},
        //     width: 200,
        //     ellipsis: true
        // },
        // {
        //     title: "Thu hộ",
        //     dataIndex: "codMoney",
        //     key: "codMoney",
        //     scopedSlots: {customRender: "codMoney"},
        //     width: 150,
        //     ellipsis: true
        // },
        // {
        //     title: "Tổng cước",
        //     dataIndex: "totalFee",
        //     key: "totalFee",
        //     scopedSlots: {customRender: "totalFee"},
        //     width: 150,
        //     ellipsis: true
        // },
        {
            title: "TL",
            dataIndex: "weightTemp",
            key: "weightTemp",
            scopedSlots: {customRender: "weightTemp"},
            width: 100,
            ellipsis: true
        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            scopedSlots: {customRender: "boxQuantity"},
            width: 100,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "freightService",
            key: "freightServiceRowGuid",
            scopedSlots: {customRender: "freightService"},
            width: 120,
            ellipsis: true
        },
        {
            title: "DV_GTGT",
            dataIndex: "freightServiceAdds",
            key: "freightServiceAdds",
            scopedSlots: {customRender: "freightServiceAdds"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            scopedSlots: {customRender: "receiverCollect"},
            width: 120,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 250,
            ellipsis: true
        },
    ];
    isExport = false;
    limitStatus = [
        LadingStatus.GdKhoiTao,
        LadingStatus.LayHangThanhCong,
        LadingStatus.LayHangThanhCongChoCapNhat,
        LadingStatus.PhatLai,
        LadingStatus.DonSuCo,
        LadingStatus.DuyetHoan,
        LadingStatus.DuyetChuyenTiep
    ];

    ladings: Array<Lading> = [];
    meta: PaginationMeta = new PaginationMeta();
    isDeleting = false;
    // selectedRowGuids = [] as any;

    async created() {
        await this.listLading(this.params);
    }

    get selectedRowGuids() {
        return LadingStore.selectedRowLadings;
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        this.handleChangeParams(val)
    }

    handleChangeParams = debounce((val) => {
        this.listLading({...val, page: 1});
    }, 500)

    onChangePage(pagination: any) {
        this.listLading({...this.params, page: pagination.current, limit: pagination.pageSize});
    }

    async listLading(params: any) {
        const data = await LadingStore.listLadingStockInWait(params);
        this.ladings = data.datas;
        this.ladings.forEach((lading: Lading) => {
            LadingStore.addLading(lading);
        })
        this.meta = data.meta;
    }

    onEnterLadingCode(evt: any) {
        this.$set(this.params, 'search', evt?.target?.value || undefined);
    }

    async onConfirmDelete(ladingId: string) {
        try {
            this.isDeleting = true;
            await deleteLading(ladingId);
            this.ladings = this.ladings.filter((lading: Lading) => lading.rowGuid !== ladingId);
            this.$message.success("Xóa vận đơn thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa vận đơn thất bại");
        } finally {
            this.isDeleting = false;
        }
    }

    changeCustomerCode(customer: any) {
        this.params = { ...this.params, customerCode: customer?.customerCode };
    }

    async exportExcel() {
        await this.getDataExport();
        setTimeout(() => {
            TableToExcel.convert(document.getElementById("table-excel-stock-in-wait"), {
                name: `Danh sách đơn chờ nhập kho.xlsx`,
                sheet: {
                    name: "Sheet 1"
                }
            });
        }, 200)
    }

    async getDataExport() {
        try {
            this.isExport = true;
            const { data } = await stockInWait({ ...this.params, page: 1, limit: 10000 });
            this.billLadingsExcel = data.datas;
        } catch (e) {
        } finally {
            this.isExport = false;
        }
    }
}
